import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../services/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Margin, Budget } from '../interfaces/index';
import { BudgetModel } from '../models/budget-model';
import { timer } from 'rxjs/observable/timer';
import { debounce, filter, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-margin-form',
  templateUrl: './margin-form.component.html',
  styleUrls: ['./margin-form.component.scss']
})
export class MarginFormComponent implements OnInit {

  private _budget: Budget;
  public formUpdating = false;

  @Input() set budget(b: Budget) {
    this._budget = b;
    if (b.margin && b.margin.generalExpenses && b.margin.commission && b.margin.profit && b.margin.customDuties) {

      if (b.margin) {
      this.marginForm.patchValue({
        generalExpenses: b.margin.generalExpenses,
        commission: b.margin.commission,
        profit: b.margin.profit,
        customDuties: b.margin.customDuties
      },
    {
      emitEvent: false
    });
    }


      if (BudgetModel.isEditable(this._budget)) {
        this.marginForm.enable();
      } else {
        this.marginForm.disable();
      }
    }
  }
  @Input() target = 'ITA';

  public marginForm: FormGroup;

  constructor(private dataService: DataService, private fb: FormBuilder) { }

  ngOnInit() {

    // TODO get Default value from settings
    const generalExpenses = this._budget.export ? 12 : 12;
    const profit = this._budget.export ? 20 : 20;

    // Definition of the Margin Form
    // build the form model
    this.marginForm = this.fb.group({
      generalExpenses: [generalExpenses, [Validators.min(0), Validators.max(100)]], // TODO get Default value from settings
      commission: [this._budget.margin ? this._budget.margin.commission : 0, [Validators.min(0), Validators.max(100)]],
      profit: [profit, [Validators.min(0), Validators.max(100)]], // TODO get Default value from settings
      customDuties: [this._budget.margin ? this._budget.margin.customDuties : 0, [Validators.min(0), Validators.max(100)]],
    });

    this.marginForm = new FormGroup(this.marginForm.controls, { updateOn: 'blur'});


    if (!BudgetModel.isEditable(this._budget)) {
      this.marginForm.disable();
    }

    // Enable auto commit
    this.onChange();

  }

  private onChange(): void {
    this.marginForm.valueChanges
    .pipe(
    debounce(() => timer(500)),
        filter(() => this.marginForm.valid),
        distinctUntilChanged((x, y) => {
          return (x.generalExpenses === y.generalExpenses &&
            x.commission === y.commission &&
            x.profit === y.profit &&
            x.customDuties === y.customDuties);
        })
    )
    .subscribe(val => {
      this.formUpdating = true;
      this.marginForm.disable();
      const margin = {
        generalExpenses: this.marginForm.value.generalExpenses,
        commission: this.marginForm.value.commission,
        profit: this.marginForm.value.profit,
        customDuties: this.marginForm.value.customDuties
      };
      this.dataService.patchBudget(this._budget.id, { margin })
        .then((data) => {
          console.log('Budget margin patched', data);
          this.formUpdating = false;
          this.marginForm.enable();
        })
        .catch((err) => {
          console.log('Budget margin ERROR', err);
          this.formUpdating = false;
          this.marginForm.enable();
        });
    });
  }

  submit() {
    const margin = {
      generalExpenses: this.marginForm.value.generalExpenses,
      commission: this.marginForm.value.commission,
      profit: this.marginForm.value.profit,
      customDuties: this.marginForm.value.customDuties
    };
    this.dataService.patchBudget(this._budget.id, { margin })
      .then((data) => {
        console.log('Budget patched', data);
      });
  }

}




// WEBPACK FOOTER //
// ./src/app/budget/components/margin-form.component.ts